import {FC} from 'react'
import {Navigate, useLocation, useParams} from 'react-router'

/**
 * Builds the native path for a legacy (Yii) URL: fills `:param` placeholders
 * in `to` from the matched route params and keeps the original query string
 * (e.g. `?date=` / `?nid=` from notifications).
 */
export const buildLegacyTarget = (
  to: string,
  params: Record<string, string | undefined>,
  search: string
): string => {
  const path = to.replace(/:([A-Za-z_]\w*)/g, (_, key: string) =>
    encodeURIComponent(params[key] ?? '')
  )
  if (!search) return path
  const joiner = path.includes('?') ? '&' : '?'
  return `${path}${joiner}${search.replace(/^\?/, '')}`
}

/**
 * Redirects an old PHP front-end URL (from notifications, emails, bookmarks or
 * links still stored in the database) to its native page, so it never falls
 * through to the legacy iframe catch-all.
 */
const LegacyRedirect: FC<{to: string}> = ({to}) => {
  const params = useParams()
  const {search} = useLocation()
  return <Navigate to={buildLegacyTarget(to, params, search)} replace />
}

export default LegacyRedirect
